/*
  YG · Quick add con gli omaggi Kaching attaccati.

  Il problema. Il bottone "Aggiungi al carrello" delle card manda solo l'id
  della variante. Gli omaggi non li applica il server: li aggiunge il
  CartInterceptor di Kaching nel browser, e solo per le offerte *registrate*.
  Fuori dalla scheda prodotto non ne e' registrata nessuna, quindi su un
  prodotto che regala qualcosa gia' a 1 pezzo il quick add mette a carrello il
  prodotto nudo, e il cliente non se ne accorge.

  Come si risolve. Non si ricostruisce niente e non si scrive mai a mano
  properties[__kaching_bundles]: si fa montare all'app il suo widget vero
  dentro il form della card. Da li' in poi fa tutto lei — registra l'offerta,
  scrive la property, aggiunge le righe omaggio.

  La sequenza, nell'ordine in cui conta:

    1. <kaching-bundle product-id="…"> va inserito DENTRO il form della card.
       _findCartForm() dell'app risale il DOM dal placeholder e si aggancia al
       primo form che trova: fuori da un form prenderebbe il form di un'altra
       card, e si aggiungerebbe l'offerta sbagliata al prodotto sbagliato.
    2. I dati dell'offerta non devono stare in pagina: l'app se li scarica da
       sola dalla sua API.
    3. La fascia si sceglie per **id**, mai per il testo del bottone, che
       cambia a ogni offerta nuova.
    4. Il widget si nasconde con clip, non con display:none: i suoi controlli
       devono restare nel DOM o l'aggancio si perde.

  Verificato: carrello con GLOBAL AGE CREMA 1x a 42,00 € piu' GOOD NIGHT a
  0,00 € (da 31,00 €), stesso id di raggruppamento, identico a quello che
  produce la scheda prodotto.

  Quando qualcosa non torna si porta alla scheda prodotto, mai si aggiunge il
  prodotto nudo: si sbaglia dalla parte che costa un clic, non un omaggio.
*/
(function () {
  'use strict';

  var SEL_CARD = '.product-card';
  var SEL_FORM = 'form[action*="/cart/add"]';
  var MS_MONTAGGIO = 6000; // quanto si aspetta che l'app monti il widget
  var MS_AL_CLIC = 4000;   /* quanto si trattiene un clic arrivato troppo presto.
                              Misurato 952 ms su desktop per essere pronti; il
                              margine serve al mobile, dove non c'e' il
                              passaggio del mouse e il touchstart precede il
                              clic di poco. Oltre la soglia si va alla scheda. */

  var perForm = new WeakMap(); // form -> Promise<'pronto'|'niente'|'fallito'>
  var attivo = false;

  function log() {
    if (window.YG_QUICK_ADD_DEBUG) console.log.apply(console, ['[yg-quick-add]'].concat([].slice.call(arguments)));
  }

  function attendi(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* Distinguere "Kaching non c'e'" da "Kaching e' cambiato": nel primo caso non
     ci sono offerte e il quick add va lasciato in pace. */
  function appPresente() {
    return !!(window.kachingBundlesEnabled || window.kachingBundlesApi ||
              document.querySelector('script[src*="kaching"]'));
  }

  function urlProdotto(form) {
    var card = form.closest(SEL_CARD);
    var a = card && card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0].split('#')[0] : null;
  }

  function idProdotto(form) {
    var i = form.querySelector('[name="product-id"]');
    return i ? i.value : null;
  }

  function leggiConfigurazione(doc) {
    var blocchi = doc.querySelectorAll('script.kaching-bundles-deal-block-settings');
    for (var i = 0; i < blocchi.length; i++) {
      var testo = (blocchi[i].textContent || '').trim();
      if (!testo) continue;
      try { return JSON.parse(testo); } catch (e) { /* si prova il prossimo */ }
    }
    return null;
  }

  /* La fascia da un pezzo, e solo se regala qualcosa: se non regala niente il
     quick add normale produce gia' il carrello giusto e non si tocca nulla. */
  function fasciaDaUnPezzoConOmaggio(cfg) {
    if (!cfg || !Array.isArray(cfg.dealBars)) return null;
    var b = cfg.dealBars.filter(function (x) {
      return x && x.quantity === 1 && Array.isArray(x.freeGifts) && x.freeGifts.length > 0;
    })[0];
    return b ? b.id : null;
  }

  function propertyDi(form) {
    return form.querySelector('input[name*="__kaching_bundles"]');
  }

  function quantitaDi(form) {
    var q = form.querySelector('[name="quantity"]');
    return q ? String(q.value) : null;
  }

  /* Il tema mostra l'attesa togliendo 'hidden' allo spinner dentro il bottone:
     si usa la sua convenzione invece di inventarne una. Senza, il cliente
     preme e per un secondo non succede niente. */
  function attesa(form, acceso) {
    var btn = form.querySelector('button[type="submit"], button[name="add"]');
    if (!btn) return;
    btn.setAttribute('aria-busy', acceso ? 'true' : 'false');
    var sp = btn.querySelector('.loading__spinner');
    if (sp) sp.classList.toggle('hidden', !acceso);
  }

  function nascondi(el) {
    el.style.cssText =
      'position:absolute!important;width:1px!important;height:1px!important;' +
      'overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;' +
      'margin:0!important;padding:0!important;border:0!important';
  }

  /* Il clic va dato sul [role=button] dentro la label della fascia: e' li' che
     l'app ascolta. Il radio da solo non sempre scatena il suo handler. */
  function scegliFascia(widget, barId) {
    var label = widget.querySelector('label[for^="' + barId + '"]');
    var bersaglio = label && (label.querySelector('[role="button"]') || label);
    if (bersaglio) { bersaglio.click(); return true; }
    var radio = widget.querySelector('input[type="radio"][value="' + barId + '"]');
    if (radio) { radio.click(); return true; }
    return false;
  }

  function inizializza() {
    if (typeof window.__kachingBundlesInitializeInternal === 'function') {
      window.__kachingBundlesInitializeInternal();
      return true;
    }
    /* Percorso supportato, se un domani l'entry interno sparisse. */
    if (typeof window.kachingBundlesInitialize === 'function') {
      window.dispatchEvent(new CustomEvent('shopify:section:load'));
      window.kachingBundlesInitialize();
      return true;
    }
    return false;
  }

  async function prepara(form) {
    if (perForm.has(form)) return perForm.get(form);

    var lavoro = (async function () {
      var url = urlProdotto(form);
      var pid = idProdotto(form);
      if (!url || !pid) return 'niente';

      // 1. questo prodotto regala qualcosa gia' a 1 pezzo?
      var cfg = null;
      try {
        var html = await fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); });
        cfg = leggiConfigurazione(new DOMParser().parseFromString(html, 'text/html'));
      } catch (e) {
        log('lettura offerta fallita', url, e && e.message);
        return 'fallito';
      }

      var barId = fasciaDaUnPezzoConOmaggio(cfg);
      if (!barId) { log(url, '→ nessun omaggio a 1 pezzo, quick add normale'); return 'niente'; }

      // 2. si fa montare il widget dentro questo form
      var widget = document.createElement('kaching-bundle');
      widget.setAttribute('product-id', pid);
      nascondi(widget);
      form.insertBefore(widget, form.firstChild);

      if (!inizializza()) { log('nessun entry di inizializzazione'); return 'fallito'; }

      var scaduto = Date.now() + MS_MONTAGGIO;
      while (Date.now() < scaduto && !propertyDi(form)) await attendi(150);
      if (!propertyDi(form)) { log(url, '→ widget non montato'); return 'fallito'; }

      // 3. fascia da un pezzo, per id
      if (!scegliFascia(widget, barId)) { log(url, '→ fascia', barId, 'non trovata'); return 'fallito'; }
      await attendi(600);

      // 4. si controlla il risultato invece di darlo per buono
      var inp = propertyDi(form);
      var prop = null;
      try { prop = JSON.parse(inp.value); } catch (e) { /* niente */ }
      if (!prop || prop.bid !== barId || quantitaDi(form) !== '1') {
        log(url, '→ stato inatteso', prop && prop.bid, quantitaDi(form));
        return 'fallito';
      }

      log(url, '→ pronto:', prop.deal, prop.bid);
      return 'pronto';
    })();

    lavoro.then(function (esito) { lavoro.__esito = esito; },
                function () { lavoro.__esito = 'fallito'; });
    perForm.set(form, lavoro);
    return lavoro;
  }

  function formDallEvento(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    /* I clic dentro il widget sono suoi: sceglie le fasce cliccando, e il
       widget vive dentro il form. Senza questa riga la scelta della fascia
       verrebbe scambiata per un "aggiungi al carrello" e devierebbe la
       pagina. Costato una prova end to end per accorgersene. */
    if (t.closest('kaching-bundle')) return null;
    var form = t.closest(SEL_FORM);
    return form && form.closest(SEL_CARD) ? form : null;
  }

  /* Solo il bottone che aggiunge davvero: un clic qualsiasi dentro la card
     (la foto, il titolo, uno swatch) non deve passare di qui. */
  function eUnInvio(e) {
    if (e.type === 'submit') return true;
    var t = e.target;
    return !!(t && t.closest && t.closest('button[type="submit"], button[name="add"], input[type="submit"]'));
  }

  function intercetta(e) {
    if (!attivo) return;
    if (!eUnInvio(e)) return;
    var form = formDallEvento(e);
    if (!form) return;

    var stato = perForm.get(form);

    /* Gia' pronto o gia' accertato che non serve: il form porta quello che
       deve, si lascia partire. */
    if (stato && stato.__esito === 'pronto') return;
    if (stato && stato.__esito === 'niente') return;

    e.preventDefault();
    e.stopPropagation();

    var url = urlProdotto(form);
    var bottone = e.target.closest ? e.target.closest('button[type="submit"], button[name="add"]') : null;
    if (!bottone) bottone = form.querySelector('button[type="submit"], button[name="add"]');
    var chiuso = false;
    attesa(form, true);
    var concludi = function (esito) {
      if (chiuso) return;
      chiuso = true;
      attesa(form, false);
      if (esito !== 'pronto' && esito !== 'niente') {
        window.location.href = url; // nel dubbio, scheda prodotto
        return;
      }
      /* Si rigioca il clic, non si chiama requestSubmit(): il gestore del tema
         e quello del carrello ascoltano il bottone, e un invio programmatico
         li scavalca facendo partire il post nativo con ricaricamento pagina.
         Al secondo giro intercetta() trova l'esito gia' deciso e lascia
         passare. */
      if (bottone) bottone.click();
      else form.submit();
    };

    Promise.race([
      prepara(form),
      attendi(MS_AL_CLIC).then(function () { return 'fallito'; })
    ]).then(concludi, function () { concludi('fallito'); });
  }

  function avvia() {
    if (!appPresente()) { log('Kaching non presente'); return; }

    var api = window.kachingBundlesApi;
    var offerte = (api && typeof api.fetchDeals === 'function')
      ? Promise.resolve().then(function () { return api.fetchDeals(); })
      : Promise.reject(new Error('fetchDeals non disponibile'));

    offerte.then(function (deals) {
      /* Se nessuna offerta regala qualcosa a 1 pezzo non c'e' niente da fare e
         lo script non tocca un solo clic. */
      attivo = Array.isArray(deals) && deals.some(function (d) {
        return (d.dealBars || []).some(function (b) {
          return b && b.quantity === 1 && (b.freeGifts || []).length > 0;
        });
      });
      log('offerte:', Array.isArray(deals) ? deals.length : '?', '· attivo:', attivo);
    }).catch(function (e) {
      attivo = true; // l'app c'e' ma non si riesce a leggerla: si resta prudenti
      log('offerte non leggibili, prudenza:', e && e.message);
    }).then(function () {
      if (!attivo) return;
      document.addEventListener('click', intercetta, true);
      document.addEventListener('submit', intercetta, true);
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (tipo) {
        document.addEventListener(tipo, function (e) {
          var form = formDallEvento(e);
          if (form && !perForm.has(form)) prepara(form);
        }, { capture: true, passive: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
